"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4260],{

/***/ 24260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _data_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84749);
/* harmony import */ var _services_Log__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27429);
/* harmony import */ var _csc_dls_Text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45468);
/* harmony import */ var _csc_dls_IconRenderer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99821);
/* harmony import */ var _csc_dls_Icons_Filter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40047);








var Select = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(__webpack_require__.e(/* import() */ 1310).then(__webpack_require__.bind(__webpack_require__, 41310)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41310)
            ];
        }
    }
});
var ReadyToShipToggle = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(__webpack_require__.e(/* import() */ 5866).then(__webpack_require__.bind(__webpack_require__, 15866)), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15866)
            ];
        }
    }
});
var FilterBar = function(param) {
    var filterOpen = param.filterOpen, toggleFilterOpen = param.toggleFilterOpen, totalNumberOfProducts = param.totalNumberOfProducts, facets = param.facets, onFilterSelected = param.onFilterSelected, _itemsPerPage = param.itemsPerPage, itemsPerPage = _itemsPerPage === void 0 ? _data_constants__WEBPACK_IMPORTED_MODULE_3__.PLP_Items_Per_Page : _itemsPerPage, _setItemsPerPage = param.setItemsPerPage, setItemsPerPage = _setItemsPerPage === void 0 ? function() {} : _setItemsPerPage;
    var readyToShipFacet = facets.find(function(f) {
        return f.type === "BOOL" && f.machineName === "readyToShip";
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "z-10 md:sticky top-0 bg-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "md:border-t md:border-b items-center flex flex-col md:flex-row",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "py-4 border-t border-b md:border-0 flex items-center w-full md:w-auto justify-between md:justify-start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            type: "button",
                            className: "cursor-pointer",
                            onClick: toggleFilterOpen,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_csc_dls_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                    id: "openCloseFilterDesktop",
                                    "data-testid": "openCloseFilterDesktop",
                                    className: "mr-6 cursor-pointer hidden items-center md:flex",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls_IconRenderer__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                            IconComponent: _csc_dls_Icons_Filter__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP,
                                            className: "mr-2"
                                        }),
                                        filterOpen ? "Close Filter" : "Filter & Sort"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_csc_dls_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                                    "data-testid": "openCloseFilterMobile",
                                    className: "mr-6 cursor-pointer flex items-center md:hidden",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls_IconRenderer__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                            IconComponent: _csc_dls_Icons_Filter__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP,
                                            className: "mr-2"
                                        }),
                                        " ",
                                        "Filter & Sort"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: readyToShipFacet && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReadyToShipToggle, {
                                onFilterSelected: onFilterSelected,
                                filter: readyToShipFacet
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_csc_dls_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    bold: true,
                    className: "pt-4 md:p-0 md:ml-auto text-gray-600 md:mr-8",
                    children: [
                        "Results (",
                        totalNumberOfProducts,
                        ")"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "hidden md:flex w-52 max-w-xs flex-row items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_csc_dls_Text__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                            className: "min-w-fit pt-4 md:p-0 md:ml-auto md:mr-4",
                            children: "Per page:"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Select, {
                            id: "Pagination_Select",
                            options: [
                                "40 items",
                                "120 items"
                            ],
                            value: "".concat(itemsPerPage, " items"),
                            onChange: function(newValue) {
                                return Promise.resolve(setItemsPerPage(parseInt("".concat(newValue)))).catch(_services_Log__WEBPACK_IMPORTED_MODULE_4__/* .error */ .vU);
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FilterBar);


/***/ }),

/***/ 99821:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var genSize = function genSize(size) {
    switch(size){
        case "2xl":
            return "w-32 h-32";
        //512x512
        case "xl":
            return "w-16 h-16";
        //64x64
        case "lg":
            return "w-8 h-8";
        //32x32
        case "md":
            return "w-5 h-5";
        //20x20
        case "sm":
            return "w-4 h-4";
        //16x16
        case "xxs":
            return "w-2 h-2";
        //8x8
        case "xs":
        default:
            //Default must be the last
            return "w-3 h-3";
    }
};
var IconRenderer = function IconRenderer(_a) {
    var IconComponent = _a.IconComponent, _b = _a.size, size = _b === void 0 ? "md" : _b, color = _a.color, loadingStyle = _a.loadingStyle, className = _a.className, rest = __rest(_a, [
        "IconComponent",
        "size",
        "color",
        "loadingStyle",
        "className"
    ]);
    var sizeClass = size && genSize(size);
    var colorStyle = color ? {
        fill: color
    } : {};
    var loadingClass = loadingStyle && "animate-".concat(loadingStyle);
    return /*#__PURE__*/ React__default["default"].createElement(IconComponent, _extends({
        style: colorStyle,
        className: "".concat(color ? color : "fill-current", " ").concat(sizeClass ? sizeClass : "", " ").concat(loadingClass ? loadingClass : "", " ").concat(className ? className : "")
    }, rest));
};
exports.IconRenderer = IconRenderer;
exports["default"] = IconRenderer; //# sourceMappingURL=IconRenderer.js.map


/***/ }),

/***/ 40047:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function(k) {
            if (k !== "default") {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function get() {
                        return e[k];
                    }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}
var React__namespace = /*#__PURE__*/ _interopNamespace(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var SvgFilter = function SvgFilter(props) {
    return /*#__PURE__*/ React__namespace.createElement("svg", _extends({
        width: "22",
        height: "14",
        viewBox: "0 0 22 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/ React__namespace.createElement("rect", {
        y: "2",
        width: "22",
        height: "1",
        fill: "black"
    }), /*#__PURE__*/ React__namespace.createElement("rect", {
        y: "11",
        width: "22",
        height: "1",
        fill: "black"
    }), /*#__PURE__*/ React__namespace.createElement("circle", {
        cx: "7.5",
        cy: "2.5",
        r: "2.5",
        fill: "black"
    }), /*#__PURE__*/ React__namespace.createElement("circle", {
        cx: "14.5",
        cy: "11.5",
        r: "2.5",
        fill: "black"
    }));
};
__webpack_unused_export__ = SvgFilter;
exports.ZP = SvgFilter; //# sourceMappingURL=Filter.js.map


/***/ }),

/***/ 45468:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
var React = __webpack_require__(67294);
function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(React);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++){
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var ThemeContext = /*#__PURE__*/ React.createContext({
    themeId: "",
    typographyComponents: {},
    brandVariables: {}
});
var useTheme = function useTheme() {
    return React.useContext(ThemeContext);
};
var TagRenderer = function TagRenderer(_a) {
    var children = _a.children, textTag = _a.textTag, rest = __rest(_a, [
        "children",
        "textTag"
    ]);
    if (typeof textTag === "string") {
        switch(textTag){
            case "h1":
                return /*#__PURE__*/ React__default["default"].createElement("h1", rest, children);
            case "h2":
                return /*#__PURE__*/ React__default["default"].createElement("h2", rest, children);
            case "h3":
                return /*#__PURE__*/ React__default["default"].createElement("h3", rest, children);
            case "h4":
                return /*#__PURE__*/ React__default["default"].createElement("h4", rest, children);
            case "h5":
                return /*#__PURE__*/ React__default["default"].createElement("h5", rest, children);
            case "h6":
                return /*#__PURE__*/ React__default["default"].createElement("h6", rest, children);
            case "span":
                return /*#__PURE__*/ React__default["default"].createElement("span", rest, children);
            case "p":
            default:
                return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
        }
    }
    return /*#__PURE__*/ React__default["default"].createElement("p", rest, children);
};
var LegacyText = function LegacyText(_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.size, size = _c === void 0 ? "md" : _c, _d = _a.bold, bold = _d === void 0 ? false : _d, _e = _a.link, link = _e === void 0 ? false : _e;
    _a.id;
    var children = _a.children, _g = _a.textTag, textTag = _g === void 0 ? "p" : _g, rest = __rest(_a, [
        "className",
        "size",
        "bold",
        "link",
        "id",
        "children",
        "textTag"
    ]);
    var classes = "".concat(!!className ? className : "", " text-body-").concat(size, "-").concat(!!link ? "link" : !!bold ? "bold" : "normal");
    return /*#__PURE__*/ React__default["default"].createElement(TagRenderer, _extends({
        className: classes,
        textTag: textTag
    }, rest), children);
};
var Text = function Text(_a) {
    var _b;
    var textId = _a.textId, className = _a.className, children = _a.children, _c = _a.textTag, textTag = _c === void 0 ? "p" : _c, rest = __rest(_a, [
        "textId",
        "className",
        "children",
        "textTag"
    ]);
    var typographyComponents = useTheme().typographyComponents;
    if (!textId || !typographyComponents) {
        return /*#__PURE__*/ React__default["default"].createElement(LegacyText, _extends({
            className: className,
            textTag: textTag
        }, rest), children);
    }
    var props = __assign({
        className: "".concat(className || "", " ").concat(textId)
    }, rest);
    var inputTag = textTag || ((_b = typographyComponents === null || typographyComponents === void 0 ? void 0 : typographyComponents[textId]) === null || _b === void 0 ? void 0 : _b.htmlComponent);
    return /*#__PURE__*/ React__default["default"].createElement(TagRenderer, _extends({
        textTag: inputTag
    }, props), children);
};
__webpack_unused_export__ = LegacyText;
__webpack_unused_export__ = Text;
exports.ZP = Text; //# sourceMappingURL=Text.js.map


/***/ })

}]);